import React from "react";

import { cn } from "../cn";

export function Card({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card" className={cn("tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-card tw-text-card-foreground tw-shadow-sm", className)} {...props} />;
}

export function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-header" className={cn("tw-flex tw-flex-col tw-gap-1.5 tw-p-6", className)} {...props} />;
}

export function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-title" className={cn("tw-font-rd-heading tw-font-semibold tw-leading-none tw-tracking-tight", className)} {...props} />;
}

export function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-description" className={cn("tw-text-sm tw-text-muted-foreground", className)} {...props} />;
}

export function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-content" className={cn("tw-p-6 tw-pt-0", className)} {...props} />;
}

export function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-footer" className={cn("tw-flex tw-items-center tw-p-6 tw-pt-0", className)} {...props} />;
}
